export function bigGallery() {
    $(".big-gallery .slider").slick({
        // arrows: false,
        infinite: true,
        speed: 800,
        // useCSS: false,
        useTransform: false,
        fade: true,
        cssEase: "linear"
    });

    let btn = document.querySelector(".btn-gallery");
    let sliderHolder = $(".big-gallery");
    let slider = document.querySelector(".slider");

    sliderHolder.mouseenter(function () {
        if ($("body").hasClass("no-touch")) {
            let windowWidth = window.innerWidth;
            btn.classList.add("show");
            slider.onmousemove = function (e) {
                let x = e.clientX;
                let y = e.clientY;
                btn.style.top = y + "px";
                btn.style.left = x + "px";
                if (x > windowWidth / 2) {
                    btn.classList.add("left");
                    btn.classList.remove("right");
                } else {
                    btn.classList.add("right");
                    btn.classList.remove("left");
                }
            };


        }
    }).mouseleave(function () {
        if ($("body").hasClass("no-touch")) {
            btn.classList.remove("show");
            btn.classList.remove("left");
            btn.classList.remove("right");
            // btn.style.top = 50 + "%";
            // btn.style.left = 50 + "%";
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/bigGallery.js